import { GAME_CONFIG } from '@utils/game/sheep/constants.js';
export default {
  name: 'SheepSlotBarComponent',
  props: {
    tiles: {
      type: Array,
      required: true
    }
  },
  computed: {
    emptySlotCount() {
      return GAME_CONFIG.maxSlots - this.tiles.length;
    }
  },
  methods: {
    handleTileClick(tile) {
      // React 中槽位点击无动作，这里可以空着
      // 如果需要触发事件可以用 this.$emit('click', tile)
    }
  }
};